/* eslint-disable no-extend-native */
Array.prototype.getClosestDown = function (find) {
  function getMedian(low, high) {
    return low + ((high - low) >> 1);
  }

  let low = 0;
  let high = this.length - 1;
  let i;

  while (low <= high) {
    i = getMedian(low, high);
    if (this[i] === find) {
      return this[i];
    }
    if (this[i] > find) {
      high = i - 1;
    } else {
      low = i + 1;
    }
  }

  return this[Math.max(0, low - 1)];
};

const initMultiPackEvents = function () {
  if ($('#subscriptionview').find('.multi-pack-list').length > 0 || $('#orderview').find('.multi-pack-list').length > 0) {
    const arrValues = [];
    $('.multi-pack-items').each(function (index, elem) {
      arrValues.push(parseInt($(elem).attr('data-quantity')));
    });

    $(document).on('change', '.input-quantity', function () {
      const value = parseInt($(this).val());
      arrValues.forEach(function (item) {
        if (value === item) {
          const updatedPriceWithMultiPack = $(`.multi-pack-items[data-quantity="${value}"]`).attr('data-unitprice-subscription');
          $('.price').find('.value').text(updatedPriceWithMultiPack);
        } else {
          const intervalLowest = $(`.multi-pack-items[data-quantity="${arrValues.getClosestDown(value)}"]`).attr(
            'data-unitprice-subscription'
          );
          $('.price').find('.value').text(intervalLowest);
        }
      });
    });
  }
};

module.exports = {
  initMultiPackEvents: initMultiPackEvents
};
